var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoundSterling = function SvgPoundSterling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.079 0.302 12.491 17.698",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.304 17.998H-.002v-2.65h12.306zm-3.477-6.895H-.062V8.521h8.889zm-4.04-5.505.273 7.304q.051 1.133-.375 1.96-.417.818-1.474 1.346l-2.25-.86a.85.85 0 0 0 .639-.435q.222-.375.298-.886.077-.52.06-.989l-.256-7.44q-.06-1.73.656-2.907A4.6 4.6 0 0 1 4.327.91Q5.572.305 7.08.305q1.295 0 2.318.392 1.032.392 1.73 1.091a4.2 4.2 0 0 1 1.032 1.619q.332.921.213 1.986l-2.958-.247q.06-.775-.255-1.27a1.8 1.8 0 0 0-.853-.733 2.8 2.8 0 0 0-1.15-.239q-.632 0-1.176.29a2.2 2.2 0 0 0-.87.887q-.324.596-.324 1.517"
  })));
};
export default SvgPoundSterling;